import { Play } from 'lucide-react'
import type { ShiftResponse } from '../types/shift.types'

export interface ShiftStatusBarProps {
  shift: ShiftResponse | null
  canStart: boolean
  isOwner: boolean
  canForceClose: boolean
  onStart?: () => void
  onEditNotes?: () => void
  onHandoff?: () => void
  onForceClose?: () => void
  isStarting?: boolean
}

export function ShiftStatusBar({
  shift,
  canStart,
  isOwner,
  canForceClose,
  onStart,
  onEditNotes,
  onHandoff,
  onForceClose,
  isStarting,
}: ShiftStatusBarProps): JSX.Element {
  if (!shift) {
    return (
      <div className="flex items-center justify-between rounded-xl border border-gray-200 bg-white p-4">
        <p className="text-sm text-gray-500">No active shift at this property.</p>
        {canStart && (
          <button
            type="button"
            onClick={onStart}
            disabled={isStarting}
            className="flex items-center gap-2 rounded-lg bg-brand-green px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
          >
            <Play className="h-4 w-4" /> Start Shift
          </button>
        )}
      </div>
    )
  }

  const started = new Date(shift.started_at).toLocaleString([], {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  })
  return (
    <div className="flex items-center justify-between rounded-xl border border-gray-200 bg-white p-4">
      <div>
        <p className="text-sm font-semibold text-gray-900">Lead: {shift.supervisor_name ?? 'Unknown'}</p>
        <p className="text-xs text-gray-400">On shift since {started}</p>
      </div>
      <div className="flex items-center gap-2">
        {isOwner && (
          <>
            <button type="button" onClick={onEditNotes} className="rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Edit Notes</button>
            <button type="button" onClick={onHandoff} className="rounded-lg bg-brand-green px-3 py-2 text-sm font-semibold text-white">Hand Off</button>
          </>
        )}
        {canForceClose && (
          <button type="button" onClick={onForceClose} className="rounded-lg border border-red-200 px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50">Force-close</button>
        )}
      </div>
    </div>
  )
}
